import TemplatesACHPage from 'components/pages/TemplatesACHPage'

export default function CaptureACHTemplatesMain(props) {
  return (
    <TemplatesACHPage />
  )
}
